import { useState, useEffect } from "react";
import Header from "../directives/header";
import { Container, Row, Col, Tab, Nav, Card, Button, Form } from "react-bootstrap";
import Footer from "../directives/footer";
import "../css/news.css"

const NewsReadMore = () => {
  const [positionClass, setPositionClass] = useState("relative");

  useEffect(() => {
    const updatePosition = () => {
      setPositionClass(window.innerWidth >= 992 ? "absolute" : "relative mb-5");
    };

    updatePosition(); // Set initial state
    window.addEventListener("resize", updatePosition);

    return () => window.removeEventListener("resize", updatePosition);
  }, []);



  return (
    <>
      <Header />
      <main style={{ paddingTop: "80px" }}>
        <div className="pt-5">
          <Container>
            <Col lg={12}>
              <div className="innerBanner mb-5">
                <Card className="rounded-5" style={{ backgroundImage: "url(assets/images/banner/bannerBitcoin.svg)" }}>
                  <Card.Body className="p-4 m-2 d-flex align-items-center">
                    <div className="text-center">
                      <h2 className="mb-1 text-white">Bitfinity Network launches Bitcoin<br />
                        L2 with $12m Bac...</h2>
                    </div>
                  </Card.Body>
                </Card>
              </div>
            </Col>
          </Container>
        </div>

        <section className="news pt-0">
          <Container>
            <Row>
              <Col lg={12} className="mb-4">
                <p className="mb-4">Curabitur blandit tempus porttitor. Nullam quis risus eget urna mollis ornare vel eu leo. Nullam id dolor id nibh ultricies vehicula ut id elit.</p>

                <p className="mb-4">Etiam porta sem malesuada magna mollis euismod. Cras mattis consectetur purus sit amet fermentum. Aenean lacinia bibendum nulla sed consectetur.</p>

                <div className="mb-4">
                  <h5 className="text-white">Heading</h5>
                  <p>Vivamus sagittis lacus vel augue laoreet rutrum faucibus dolor auctor. Duis mollis, est non commodo luctus, nisi erat porttitor ligula, eget lacinia odio sem nec elit. Morbi leo risus, porta ac consectetur ac, vestibulum at eros.</p>
                </div>
                <div className="mb-4">
                  <h5 className="text-white">Sub-heading</h5>
                  <p>Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus.</p>
                </div>
                <p>Example code block Aenean lacinia bibendum nulla sed consectetur. Etiam porta sem malesuada magna mollis euismod. Fusce dapibus, tellus ac cursus commodo. Tortor mauris condimentum nibh, ut fermentum massa.</p>

                <div className="">
                  <h5 className="text-white">Sub-heading</h5>
                  <p>Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Aenean lacinia bibendum nulla sed consectetur. Etiam porta sem malesuada magna mollis euismod. Fusce dapibus, tellus ac cursus commodo, tortor mauris condimentum nibh, ut fermentum massa justo sit amet risus.</p>
                </div>
              </Col>
            </Row>
          </Container>
        </section>
      </main>
      <Footer />
    </>
  );
};
export default NewsReadMore;
